import type { MetaMatches } from '@react-router/react/dist/routeModules';
import type { RootLoaderData } from '~/root';

export const getMetaBaseUrl = <T extends { root: RootLoaderData }>( matches: MetaMatches<T> ) : string => {
  return ( matches.find( m => m.id === 'root' )?.data as RootLoaderData ).baseUrl;
}
